module.exports = __webpack_public_path__ + "static/media/card-warning.24e54b66.png";